import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import Seo from '@/components/Seo';
import { BASE_URL, getHreflangLinks, getPageMeta } from '@/seo/meta';
import { stripLanguagePrefix, withLanguagePrefix, useLocalizedPath } from '@/lib/locale';

export default function NotFound() {
  const { language } = useLanguage();
  const location = useLocation();
  const localizedPath = useLocalizedPath();
  const locale = language === 'en' ? 'en' : 'el';
  const meta = getPageMeta('not-found', undefined, locale);
  const canonicalPath = withLanguagePrefix(stripLanguagePrefix(location.pathname), locale);
  const canonicalUrl = `${BASE_URL}${canonicalPath}`;
  const hreflang = getHreflangLinks(location.pathname, locale);
  const copy = {
    title: locale === 'en' ? 'Page not found' : 'Η σελίδα δεν βρέθηκε',
    description:
      locale === 'en'
        ? 'The page you are looking for might have moved or no longer exists. Head back home or explore our services.'
        : 'Η σελίδα που αναζητάτε μπορεί να μετακινήθηκε ή να μην υπάρχει. Επιστρέψτε στην αρχική ή εξερευνήστε τις υπηρεσίες μας.',
    home: locale === 'en' ? 'Home' : 'Αρχική',
    services: locale === 'en' ? 'Services' : 'Υπηρεσίες',
  };

  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center px-6 text-center">
      <Seo
        title={meta.title}
        description={meta.description}
        url={canonicalUrl}
        hreflang={hreflang}
        image={meta.image}
        noindex
      />
      <h1 className="text-4xl font-extrabold tracking-tight">{copy.title}</h1>
      <p className="mt-4 text-white/80 max-w-lg">
        {copy.description}
      </p>
      <div className="mt-8 flex gap-4">
        <Link
          to={localizedPath('/')}
          className="inline-flex items-center rounded-lg px-5 py-3 font-medium glassmorphic-button text-white"
        >
          {copy.home}
        </Link>
        <Link
          to={localizedPath('/services')}
          className="inline-flex items-center rounded-lg px-5 py-3 font-medium border border-white/20"
        >
          {copy.services}
        </Link>
      </div>
    </div>
  );
}
